import React, { useLayoutEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ETFCapitalGainsDistributions from './EtfCapitalGainsDistributions.jsx'
import CapitalGainsDistributions from './CapitalGainsDistributions.jsx'
import CapitalGainsEstimates from './CapitalGainsEstimates.jsx'
import CapitalGainsCalendarYearDistributions from './CapitalGainsCalendarYearDistributions.jsx'
import CapitalGainsCalendarYearDistributionReports from './CapitalGainsCalendarYearDistributionReports.jsx'
import { isPresented } from '../../Helpers/FundUtility.js'
import {
  ETF_FUND,
  INTERVAL_FUND,
  MUTUAL_FUND,
} from '../../Helpers/FundTypes.js'
import { isEtf } from '../../Helpers/CheckProductType.js'
import {
  getDistributionReports,
  getCapGainsDistReports,
} from '../../Data/FundDetailsDataSource.js'
import { getDownloadCapGains } from '../../../../spa/components/investmentProducts/InvestmentProductsDataSource.js'
import DataNotAvailable from '../../Helpers/DataNotAvailable.js'

function CapitalGains({
  fund,
  fundSubscription,
  setFundSubscription,
  subscriptionProfile,
  showEmailSubscriptionModal,
}) {
  const [reports, setReports] = useState()
  const [hasFilteredReports, setHasFilteredReports] = useState(true)
  const [capGainsDistReports, setCapGainsDistReports] = useState()

  useLayoutEffect(() => {
    initializeData()
  }, [])

  const initializeData = async () => {
    const fetchCapGainsDistReports = async (cusip) => {
      const _reports = await getCapGainsDistReports(cusip)
      setCapGainsDistReports(_reports)
    }
    if ([MUTUAL_FUND, INTERVAL_FUND].includes(fund.fundGroup)) {
      fetchCapGainsDistReports(fund.cusip)
    }
    const disReports = await getDistributionReports()
    setReports(disReports)
  }

  const distributionReports =
    fund.etfDistributions &&
    fund.etfDistributions.length > 0 &&
    isPresented(fund, 'etfDistributions')
      ? fund.etfDistributions
      : capGainsDistReports
  return (
    <section
      className="section-content u-adel-reset"
      data-section-content="capital-gains"
      id="capital-gains"
    >
      <div className="u-sizeConstrained">
        <hr className="Rule Rule--thin Module-divider" role="presentation" />
        <div className="u-paddingVert12gu">
          <h2 className="u-marginBottom5gu">Capital Gains &amp; Dividends</h2>
          {distributionReports ||
          fund.calendarYearDistributionDetail ||
          hasFilteredReports ? (
            <div>
              {distributionReports &&
                (isEtf(fund.miscellaneousDetails) ? (
                  <ETFCapitalGainsDistributions
                    distributions={distributionReports}
                  />
                ) : distributionReports.value?.productDetail.capitalGains
                    .length > 0 &&
                  isPresented(
                    distributionReports.value.productDetail,
                    'capitalGains'
                  ) ? (
                  <CapitalGainsDistributions
                    distributions={distributionReports}
                    getDownload={getDownloadCapGains}
                    fund={fund}
                  />
                ) : null)}
              {distributionReports?.value?.productDetail?.capitalGainsEstimates
                .length > 0 &&
                isPresented(
                  distributionReports.value.productDetail,
                  'capitalGainsEstimates'
                ) && (
                  <CapitalGainsEstimates
                    distributions={distributionReports}
                    getDownload={getDownloadCapGains}
                    fund={fund}
                  />
                )}
              {fund.calendarYearDistributionDetail &&
                isPresented(fund, 'calendarYearDistributionDetail') && (
                  <CapitalGainsCalendarYearDistributions
                    calendarYearDistributions={
                      fund.calendarYearDistributionDetail
                    }
                  />
                )}
              {hasFilteredReports && (
                <CapitalGainsCalendarYearDistributionReports
                  reports={reports}
                  isEtf={fund.fundGroup === ETF_FUND}
                  isMutualFund={fund.fundGroup === MUTUAL_FUND}
                  isIntervalFund={fund.fundGroup === INTERVAL_FUND}
                  subscriptionProfile={subscriptionProfile}
                  fundSubscription={fundSubscription}
                  setFundSubscription={setFundSubscription}
                  showEmailSubscriptionModal={showEmailSubscriptionModal}
                  setHasFilteredReports={setHasFilteredReports}
                />
              )}
            </div>
          ) : (
            <DataNotAvailable />
          )}
        </div>
      </div>
    </section>
  )
}

CapitalGains.propTypes = {
  fund: PropTypes.object.isRequired,
  fundSubscription: PropTypes.object,
  setFundSubscription: PropTypes.func.isRequired,
  subscriptionProfile: PropTypes.object,
  showEmailSubscriptionModal: PropTypes.bool.isRequired,
}

export default CapitalGains
